/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ICreateInternalRegulationObligationProcessMutationVariables = Types.Exact<{
  input: Types.ICreateInternalRegulationObligationProcessInput;
}>;

export type ICreateInternalRegulationObligationProcessMutation = {
  __typename?: 'Mutation';
  createInternalRegulationObligationProcess: {
    __typename?: 'InternalRegulationObligationProcess';
    id: string;
    processCode?: string | null;
    processName?: string | null;
    processDescription?: string | null;
  };
};

export const CreateInternalRegulationObligationProcessDocument = gql`
  mutation CreateInternalRegulationObligationProcess($input: CreateInternalRegulationObligationProcessInput!) {
    createInternalRegulationObligationProcess(input: $input) {
      id
      processCode
      processName
      processDescription
    }
  }
`;
export type ICreateInternalRegulationObligationProcessMutationFn = Apollo.MutationFunction<
  ICreateInternalRegulationObligationProcessMutation,
  ICreateInternalRegulationObligationProcessMutationVariables
>;

/**
 * __useCreateInternalRegulationObligationProcessMutation__
 *
 * To run a mutation, you first call `useCreateInternalRegulationObligationProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalRegulationObligationProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalRegulationObligationProcessMutation, { data, loading, error }] = useCreateInternalRegulationObligationProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalRegulationObligationProcessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateInternalRegulationObligationProcessMutation,
    ICreateInternalRegulationObligationProcessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateInternalRegulationObligationProcessMutation,
    ICreateInternalRegulationObligationProcessMutationVariables
  >(CreateInternalRegulationObligationProcessDocument, options);
}
export type CreateInternalRegulationObligationProcessMutationHookResult = ReturnType<
  typeof useCreateInternalRegulationObligationProcessMutation
>;
export type CreateInternalRegulationObligationProcessMutationResult =
  Apollo.MutationResult<ICreateInternalRegulationObligationProcessMutation>;
export type CreateInternalRegulationObligationProcessMutationOptions = Apollo.BaseMutationOptions<
  ICreateInternalRegulationObligationProcessMutation,
  ICreateInternalRegulationObligationProcessMutationVariables
>;
